/* eslint-disable react/prop-types */
import React, {  } from "react";
import axios from "axios";
import { Button } from "react-bootstrap";

const DeleteRegisterEntry = (props) => {
    const Participant = props.Participant;
    const type = props.type;
    const deleteFromRegister = async () => {
      props.setSubmitClicked(true);
      const deleteRequest = await axios.delete(
        `/api/admin/registers/adhoc_delete/${type}/`,
        { data: { entryID: Participant._id, parentID: props.parentID } },
        {
          withCredentials: true,
        }
      );
      if (deleteRequest.status === 200) {
        props.fetchNewData();
        return props.setSubmitClicked(false);
      } else {
        props.setSubmitClicked(false);
        window.scrollTo(10, 0);
        return props.setErrorMessage("There was a problem with that request.");
      }
    };
    return (
      <td td className='align-self-center align-middle'>
        {Participant.StripeStatus === "Adhoc!" || Participant.Status === "Adhoc!" ? (
          <Button
            variant='danger'
            size='sm'
            type='submit'
            value={Participant._id}
            onClick={deleteFromRegister}
          >
            Delete
          </Button>
        ) : (
          <Button variant='secondary' size='sm' type='submit' disabled>
            N/A
          </Button>
        )}
      </td>
    );
  };

  export default DeleteRegisterEntry;